import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import raw from 'raw.macro';
import ReactMarkdown from 'react-markdown'
import gfm from 'remark-gfm';
import { ReactComponent as HelpIcon } from '../assets/icons/information.svg';
import {useLocation } from 'react-router-dom';
import { useMatomo } from '@jonkoops/matomo-tracker-react';

/**
 * Dynamic help page.
 */
export default function Help({
  ...props
}) {
  const [ show, setShow ]         = useState(false);
  const [ markdown, setMarkdown ] = useState('');
  const { pathname }              = useLocation();
  const { trackEvent }            = useMatomo();
  const iconSize                  = '1.5em';

  useEffect(
    () => {
      const loadPath = pathname.replace('/', '_');
      const markdownData = raw(`../helpfiles/${ loadPath }.MD`);
      setMarkdown(markdownData === undefined ? '' : markdownData);
    },
    [pathname]
  );

  return (
      markdown === '' ? (
        null
      ) : (
        <>
          <HelpIcon
            style={{ height: iconSize, width: iconSize, position: "relative", top: "0.35em", cursor: 'pointer' }}
            alt = 'help'
            onClick={() => {
              // Track the event.
              trackEvent({
                category: 'help',
                action: 'show',
                name: pathname,
              });
              setShow(true)
            }}
          />
          <Modal show={show} size="lg" onHide={ () => setShow(false) }>
            <Modal.Header closeButton>
              <Modal.Title>Help</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <ReactMarkdown remarkPlugins={[gfm]}>{ markdown }</ReactMarkdown>   
            </Modal.Body>
          </Modal>
        </>
      )
  )
}
